function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: ""
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8567 8.17254C15.759 7.76204 15.6145 7.36968 15.4292 7.00152C15.2546 6.65485 15.0437 6.32961 14.8016 6.03069C14.5637 5.73726 14.2958 5.46922 14.0024 5.23147C13.7035 4.98919 13.3783 4.77827 13.0317 4.6037C12.6637 4.4183 12.2715 4.27384 11.8612 4.17622C11.459 4.08061 11.0393 4.02991 10.6079 4.02991V5.42952V7.02747V8.62591V9.42464H11.4076H13.0061H14.6045H16.0026C16.0026 8.99361 15.952 8.57443 15.8567 8.17254Z",
  fill: "#A2E786"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8039 10.6235C14.8039 13.6029 12.3886 16.0182 9.40914 16.0182C7.91948 16.0182 6.57079 15.4144 5.59457 14.4381C4.61827 13.4618 4.0144 12.1131 4.0144 10.6235C4.0144 7.64408 6.42969 5.22876 9.40914 5.22876V10.6235H14.8039Z",
  fill: "#F2D231"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.40905 10.6235H14.8038C14.8038 13.6029 12.3885 16.0182 9.40905 16.0182C7.91936 16.0182 6.57068 15.4144 5.59448 14.438L9.40905 10.6235Z",
  fill: "#DA1D81"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8567 8.17258L14.6045 9.42468H13.0061L15.4291 7.00165L15.4291 7.00159C15.6145 7.36975 15.759 7.76211 15.8567 8.17258ZM14.8016 6.03073L14.8015 6.03079L11.4076 9.42468H10.6079V8.62595L14.0024 5.23151C14.2957 5.46926 14.5637 5.73733 14.8016 6.03073Z",
  fill: "#00CB75"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.0316 4.60369L13.0316 4.60375L10.6079 7.02743V5.42948L11.8612 4.17627V4.17621C12.2715 4.27387 12.6636 4.41832 13.0316 4.60369Z",
  fill: "#00CB75"
});

const SvgMultiMarkets = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "4.01 4.03 11.99 11.99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMultiMarkets, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/multi_markets.bc8f66b0.svg";
export { ForwardRef as ReactComponent };